import ApiManager from '@/utils/ApiManager'
import Constants from '@/utils/Constants'
import Utility from '@/utils/Utility'
import Vue from 'vue'

const state = {
  categoryName: 'Dropbox',

  // 選択サービス名
  serviceName: null,
  
  // model
  dropboxModel: [],

  // form
  targetId: Constants.RegisterHash,
  values: {}
}

const getters = {
  get: state => state,

  // form mode
  isRegister: state => state.targetId === Constants.RegisterHash,
  isModify: state => state.targetId !== Constants.RegisterHash,
  
  // 登録値を表示用に変換
  getValue: state => (key) => {
    try {
      let value = state.values[key]
      switch (key) {
        default:
          return value
      }
    /* eslint-disable no-new */
    } catch (e) {
      return ''
    }
  }
}

const actions = {
  /**
   * 初期データを読出し
   */
  loadModel ({commit}, {dropboxParams}) {
    return new Promise((resolve, reject) => {
      ApiManager.request(
        ['serviceDropbox'],
        ['v1ServiceDropboxListGet'],
        [dropboxParams])
        .then(res => {
          let status = Utility.parseResponse(res)

          if (status.result) {
            commit('setServiceName', res[0].data.serviceName)
            commit('setDropboxModel', res[0].data.serviceDropboxSettings)
            console.log('dropboxModel', state.dropboxModel)
            resolve()

          } else if (status.error) {
            // エラーメッセージ表示
            reject(res)
          } else {
            // アプリケーションエラー表示
            reject(null)
          }
        })
        .catch(error => {
          // アプリケーションエラー表示
          reject(null)
        })
    })
  },

  /**
   * フォームの初期化
   */
  initRegister ({commit}) {
    commit('setTargetId', Constants.RegisterHash)
    commit('initRegister')
  },
  initModify ({commit}, {data}) {
    commit('setTargetId', data.DeliveryTypeMstId)
    commit('initModify', data)
  },

  /**
   * リセット
   */
  reset ({commit}) {
    commit('reset')
  }
}

const mutations = {
  // service name
  setServiceName (state, str) {
    state.serviceName = str
  },

  // model
  setDropboxModel (state, data) {
    Vue.set(state, 'dropboxModel', data)
  },

  // form
  setTargetId (state, targetId) {
    state.targetId = targetId
  },
  setValues (state, values) {
    Vue.set(state, 'values', values)
  },
  setInputValue (state, {key, value}) {
    Vue.set(state.values, key, value)
  },

  // form mode
  initRegister (state) {
    Vue.set(state.values, 'inpDropboxName', null)
    Vue.set(state.values, 'inpToken', null)
    Vue.set(state.values, 'inpFolderName', null)
    Vue.set(state.values, 'inpDataKbn', '')
  },
  initModify (state, data) {
    Vue.set(state, 'values', data)
    Vue.set(state.values, 'inpDropboxName', data.dropboxName)
    Vue.set(state.values, 'inpToken', data.dropboxToken)
    Vue.set(state.values, 'inpFolderName', data.dropboxFolderName)
    Vue.set(state.values, 'inpDataKbn', data.dataKbn)
  },

  // reset
  reset (state) {
    state.targetId = Constants.RegisterHash
    Vue.set(state, 'values', {})
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
